module.exports = __webpack_public_path__ + "static/img/2.1918727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/2.png
// module id = FPQ7
// module chunks = 1